import { render } from "./CustomColumn.vue?vue&type=template&id=31a40726&ts=true"
import script from "./CustomColumn.vue?vue&type=script&lang=ts"
export * from "./CustomColumn.vue?vue&type=script&lang=ts"

import "./CustomColumn.vue?vue&type=style&index=0&id=31a40726&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__